import { isWithinLast } from '../is-within-last/index.tsx';

export const isWithinLast14Days = isWithinLast({ days: 14 });
